/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type OrgPCCActivationStatus = typeof OrgPCCActivationStatus[keyof typeof OrgPCCActivationStatus];


export const OrgPCCActivationStatus = {
  Inactive: 'Inactive',
  Pending: 'Pending',
  Active: 'Active',
} as const;
